<template>
   <g>
      <path
         d="M1.36485 11.8015H11.6351C12.6854 11.8015 13.34 10.6627 12.8149 9.75566L7.67979 0.883379C7.15468 -0.0236262 5.84532 -0.0236262 5.32021 0.883379L0.185064 9.75566C-0.340044 10.6627 0.314636 11.8015 1.36485 11.8015ZM6.5 7.02783C6.12492 7.02783 5.81804 6.72094 5.81804 6.34587V4.98195C5.81804 4.60687 6.12492 4.29999 6.5 4.29999C6.87508 4.29999 7.18196 4.60687 7.18196 4.98195V6.34587C7.18196 6.72094 6.87508 7.02783 6.5 7.02783ZM7.18196 9.75566H5.81804V8.39174H7.18196V9.75566Z"
         fill="#FFAE00"
      />
   </g>
</template>

<script>
export default {
   data() {
      return {
         name: 'icon-flag-verify',
         viewBox: '0 0 13 12',
         width: 13,
         height: 12,
      };
   },
};
</script>
